(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Initialize Country/Province Selectors
    if (typeof Shopify !== 'undefined' && Shopify.CountryProvinceSelector) {
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });

      // Initialize for each edit form
      const editCountrySelects = document.querySelectorAll('[id^="AddressCountry_"]');
      editCountrySelects.forEach(select => {
        const formId = select.dataset.formId;
        if (formId) {
          new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
            hideElement: `AddressProvinceContainer_${formId}`
          });
        }
      });
    }

    // Toggle Add Address Form
    const addButton = document.querySelector('.add-address-btn');
    const addForm = document.getElementById('AddAddress');
    
    if (addButton && addForm) {
      addButton.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !isExpanded);
        addForm.hidden = isExpanded;
        
        if (!isExpanded) {
          addForm.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    }

    // Toggle Edit Address Forms
    const editButtons = document.querySelectorAll('.edit-address-btn');
    editButtons.forEach(button => {
      button.addEventListener('click', function() {
        const formId = this.getAttribute('aria-controls');
        const form = document.getElementById(formId);
        
        if (form) {
          const isExpanded = this.getAttribute('aria-expanded') === 'true';
          this.setAttribute('aria-expanded', !isExpanded);
          form.hidden = isExpanded;
          
          if (!isExpanded) {
            form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }
      });
    });

    // Cancel Buttons
    const cancelButtons = document.querySelectorAll('.cancel-address-btn');
    cancelButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const form = this.closest('.customer-addresses__form');
        
        if (form) {
          form.hidden = true;
          const formId = form.id;
          const toggleButton = document.querySelector(`[aria-controls="${formId}"]`);
          
          if (toggleButton) {
            toggleButton.setAttribute('aria-expanded', 'false');
            toggleButton.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }
      });
    });

    // Delete Address Buttons
    const deleteButtons = document.querySelectorAll('.delete-address-btn');
    deleteButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const confirmMessage = this.dataset.confirmMessage;
        
        if (confirm(confirmMessage)) {
          const target = this.dataset.target;
          if (target) {
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = target;

            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = '_method';
            input.value = 'delete';
            form.appendChild(input);

            document.body.appendChild(form);
            form.submit();
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
